import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "spire-cookie-consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    window.dispatchEvent(new CustomEvent("spire-consent", { detail: value }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 p-4 sm:p-6"
      role="dialog"
      aria-label="Cookie consent"
      aria-live="polite"
      data-testid="cookie-banner"
    >
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg border border-stone-200 p-6 sm:p-8">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-start">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-orange-50 text-orange-700">
            <Cookie className="h-6 w-6" aria-hidden="true" />
          </span>
          <div className="flex-1">
            <h2 className="font-heading text-xl font-semibold text-stone-900">
              We use cookies
            </h2>
            <p className="mt-2 text-base text-stone-700 leading-relaxed">
              We use essential cookies to make this site work. We would also like to use optional
              cookies to understand how the site is used. You can accept or decline optional
              cookies. Read our{" "}
              <Link
                to="/cookie-policy"
                className="font-semibold text-orange-700 underline"
                data-testid="cookie-banner-policy-link"
              >
                Cookie Policy
              </Link>
              .
            </p>
            <div className="mt-5 flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                onClick={() => choose("accepted")}
                className="px-6 py-3 rounded-xl bg-orange-600 text-white font-semibold text-lg hover:bg-orange-700 transition-colors"
                data-testid="cookie-accept-button"
              >
                Accept all
              </button>
              <button
                type="button"
                onClick={() => choose("declined")}
                className="px-6 py-3 rounded-xl bg-white text-stone-900 border-2 border-stone-300 font-semibold text-lg hover:border-orange-600 hover:bg-orange-50 transition-colors"
                data-testid="cookie-decline-button"
              >
                Decline optional
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
